<template lang="pug">
    v-snackbar(:bottom='!alignTop' :top='alignTop' auto-height v-model="vuexShow" small
        :color="typeStyle.backColor"
        :timeout="timeoutState")
        v-icon(v-if="typeStyle!=''") {{typeStyle.leftIcon}}
        //- v-spacer
        //- v-container(v-if="message.title===null")
        //-     v-flex
        //-         .body-1 {{message.body}}
        //- v-container(v-else fluid align-baseline)
        v-container
            v-flex(v-if="message.title!=null")
                .title.font-weight-light {{message.title}}
            v-flex
                .body-1 {{message.body}}
        v-spacer
        div
            v-progress-circular(v-if="showProgress" indeterminate size='30' ma-10)
        v-btn(v-if="enableConfirm" flat color="white"  @click="confirmAction(messageConfirm)" ) {{messageConfirm}}
        v-btn(v-if="closeOptions.show" flat @click="hideSnack") {{closeOptions.text}}
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
    name: 'snackbar-modal',
    data() {
        return {
            show: false,
            tout: false,
        }
    },
    

    computed: {
        ...mapState('SnackbarModalModule', {
            typeMessage: state => state.typeMessage, //success | warning | info | error,
            showSnack: state => state.showSnack,
            showProgress: state => state.showProgress,
            timeoutState: state => state.timeout,
            closeOptions: state => state.closeOptions, // {text: 'close', show: false}
            message: state => state.message, // {title: '', body: ''}
            enableConfirm: state=>state.enableConfirm,
            messageConfirm: state=>state.messageConfirm,
            alignTop: 'alignTop',
        }),
        
        /**
         * @description
         */
        vuexShow: {
            get: function(){
                return this.showSnack
            },
            set: function(newVal){
                if(!newVal){
                    this.resetSnackbarState()
                }
                return newVal
                
            }
        },
        ...mapGetters('SnackbarModalModule', {
            typeStyle: 'typeStyle',
        }),

        // show() {
        //     return this.showSnackbar
        // }


    },

    methods: {
        ...mapActions('SnackbarModalModule', {
            //initSnackbar:       'initSnackbar',
            //setType:    'setType',
            hideSnack: 'hideSnack',
            //showSnack:  'showSnack',
            responseConfirm : 'responseConfirm',
            resetSnackbarState: 'resetSnackbarState',
            //showClose:  'showClose',
            //hideClose:  'hideClose',
        }),
        confirmAction(identifierAction){
            this.responseConfirm(identifierAction)
        }
        
    },

    watch: {
        // /**
        //  * @description
        //  */
        // showSnack(newVal, oldVal) {
        //     //this.show = false
        //     // console.log("showSnackbar:")
        //     // console.log(this.showSnackbar)
        //     console.log('showSnack updated to', newVal)
        //     this.show = newVal
        // },

        /**
         * @description
         */
        timeoutState(newVal, oldVal) {
            this.tout = newVal
        }
    }

    // created: function() {
    //     this.$store.watch(
    //         state => state.snackbar.snack,
    //         () => {
    //             const msg = this.$store.state.snackbar.snack
    //             if (msg !== '') {
    //                 this.show = true
    //                 this.message = this.$store.state.snackbar.snack
    //                 this.$store.commit('snackbar/setSnack', '')
    //             }
    //         }
    //     )
    // },
}
</script>

<style scoped>
/* .danger {
    background-color: red !important;
    border-color: red !important;
} */
</style>